import { Button } from '@latitude/button';
import { Drawer } from '@latitude/drawer';
import { Text } from '@latitude/text';
import type { LANDING_PAGE_DRAWERS } from 'components/LandingPage/helpers';
import { getLandingPageDrawerContent } from 'components/LandingPage/helpers';
import { useFormType } from 'hooks/useFormType/useFormType';

import {
  AML_DRAWER_CONTENT,
  ECP_DRAWER_CONTENT,
  ECP_EVIDENCE_DRAWER_CONTENT,
  TRADING_AUTH_DRAWER_CONTENT,
} from './helpers';

export const AML_DRAWER = 'AML_DRAWER';
export const ECP_DRAWER = 'ECP_DRAWER';
export const ECP_EVIDENCE_DRAWER = 'ECP_EVIDENCE_DRAWER';
export const TRADING_AUTH_DRAWER = 'TRADING_AUTH_DRAWER';

const DRAWER_CONTENT = {
  [AML_DRAWER]: AML_DRAWER_CONTENT,
  [ECP_DRAWER]: ECP_DRAWER_CONTENT,
  [ECP_EVIDENCE_DRAWER]: ECP_EVIDENCE_DRAWER_CONTENT,
  [TRADING_AUTH_DRAWER]: TRADING_AUTH_DRAWER_CONTENT,
} as const;

export type DrawerID = LANDING_PAGE_DRAWERS | keyof typeof DRAWER_CONTENT;

type Props = {
  isOpen: boolean;
  onClose: () => void;
  drawerID: DrawerID;
};

const isContentDrawer = (id: DrawerID): id is keyof typeof DRAWER_CONTENT =>
  id in DRAWER_CONTENT;

const getDrawerContent = (
  id: DrawerID,
  isA1Application: boolean,
  isAdsdApplication: boolean,
  isArmadaApplication: boolean,
) => {
  if (isContentDrawer(id)) {
    return DRAWER_CONTENT[id];
  }
  const landingPageContent = getLandingPageDrawerContent(
    id,
    isA1Application,
    isAdsdApplication,
    isArmadaApplication,
  );
  return {
    title: landingPageContent?.title,
    content: landingPageContent?.content,
  };
};

const InfoDrawer = ({ drawerID, isOpen, onClose }: Props) => {
  const { isA1Application, isAdsdApplication, isArmadaApplication } =
    useFormType();
  const { title, content } = drawerID
    ? getDrawerContent(
        drawerID,
        isA1Application,
        isAdsdApplication,
        isArmadaApplication,
      )
    : { title: '', content: null };

  return (
    <Drawer
      width={640}
      onOpenChange={onClose}
      open={isOpen}
      contentStyles={{ padding: 0 }}
      footer={
        <Button className="ml-auto w-fit" onClick={onClose}>
          Close
        </Button>
      }
      title={<Text variant="headingSmall">{title}</Text>}
    >
      <div className="flex h-full flex-col gap-4 overflow-scroll">
        {content}
      </div>
    </Drawer>
  );
};

export default InfoDrawer;
